module.exports = __webpack_public_path__ + "static/c3-9db06c1b04a2c6e3c4dca8363174fafc.png";